<template>
  <div class="Program-styles-program Program-styles-desktop" testid="Program_ONE_HOUR_WIDGET">
    <div class="styles-app-structure-program-widget-title" v-show="!highlight">{{ t.sportsbook.filter.upcoming }}</div>
    <div class="styles-app-structure-program-widget-title" v-show="highlight">{{ t.sportsbook.filter.highlight }}</div>

    <div class="HorizontalScroller-styles-container SportTabs-styles-container SportTabs-styles-shadow" v-if="events">
      <div class="HorizontalScroller-styles-child-container HorizontalScroller-styles-child-animation" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
        <div v-for="sport in sortAByKey(events, 'order')">
          <a v-on:click="go(sport)" :class="(sport.sportId === currentSport) ? 'TabButton-styles-tab-button-active active' : ''" aria-current="page" class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-full-width" id="tab-button-soccer" testid="Button_tab_button_soccer" href="javascript:;">
            <div class="">{{ sport.name }}</div>
          </a>
        </div>
      </div>
      <div @click="moveCarousel(-1)" v-show="!atHeadOfList" class="HorizontalScroller-styles-arrow-container HorizontalScroller-styles-arrow-container-left HorizontalScroller-styles-arrow-animation"><img src="/static/assets/img/scroll-arrow-left.svg" class="HorizontalScroller-styles-arrow"></div>
      <div @click="moveCarousel(1)" class="HorizontalScroller-styles-arrow-container HorizontalScroller-styles-arrow-container-right EventCards-styles-arrow-container HorizontalScroller-styles-arrow-animation"><img src="/static/assets/img/scroll-arrow-right.svg" class="HorizontalScroller-styles-arrow"></div>
    </div>

  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import sportIcon from '@/components/ui/asset/sportIcon';
export default {
  name: 'upcomingToolbar',
  components: {sportIcon},
  props: {
    onlive: {
      default: null
    },
    highlight: {
      default: false
    }
  },
  data() {
    return {
      t: this.$root.t,
      currentTime: '+24 hours',
      events: null,
      currentSport: 1,
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 100,
    }
  },
  beforeDestroy() {
    clearInterval(window.EventIntervalToolbar);
  },
  mounted () {
    clearInterval(window.EventIntervalToolbar);
    window.EventIntervalToolbar = setInterval(this.fetchEvents, 50000);
    this.fetchEvents();
  },
  computed: {
    atEndOfList() {
      return this.currentOffset <= (this.paginationFactor * -1) * (this.events.length - this.windowSize);
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  methods: {
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    go (sport) {
      this.currentSport = sport.sportId;
      this.$emit('selected', {upcoming: this.currentTime, sport: this.currentSport});
    },
    changeTime(time) {
      this.currentTime = time;

      this.$emit('selected', {upcoming: this.currentTime, sport: this.currentSport});
    },
    async fetchEvents () {
      if(window.windowFocused){
        this.$http.get(bsapi + 'matches.aspx?_=dynamic', {
          params: {
            app: this.$root.app.id,
            withoutMatch: 1,
            onLive: this.onlive,
            per_page: 999999999,
          }
        }).then(response => {
          // get body data

          if(response.body.result)
            this.events = response.body.result.sport;


        }, response => {

        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.swiper-button-disabled {
  display: none;
}
.swiper-container {
  width: 100%;
}

.nav-item {
  font-size: 11px
}
i {
  font-size: 11px;
  display: none;
}
.tabs-style-iconbox {
  border-bottom: 3px solid #f64835;
  background: #fff;
}

.tabs-style-iconbox .header {
  float: left;
  position: absolute;
}
.tabs-style-iconbox .header {
  font-size: 20px;
  padding: 2px 5px 2px 15px;
  font-weight: bold
}

.tabs-style-iconbox nav ul li {
  margin: 0;
  height: 35px;
  width: 100%;}

.tabs-style-iconbox nav ul li a {
  width: 100%;
  float: left;
  display: block;
  color: #666;
}
.tabs-style-iconbox nav ul li.tab-current a{
  color: white;

}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  right: 0;
}
.tabs-style-iconbox nav ul li:first-child::before, .tabs-style-iconbox nav ul li::after {
  height: 100%;
  top: 0;
}
.tabs nav a span {
  font-size: 12px;
  font-weight: bold;
}
.right-nav {
  width: 40%;
  float: right;
}
.left-nav {
  width: 60%;
  float: left;
}
.left-nav li{
  min-width: 60px;
  width: auto !important;
  float: right !important;
}
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/upcomingToolbar.vue